"use strict";Object.defineProperty(exports,"__esModule",{value:!0});exports.fetchJSON=(e,t)=>new Promise(((o,s)=>{fetch(e,t).then((e=>{e.ok?o(e.json()):s(e)})).catch((e=>s(e)))}));
//# sourceMappingURL=index.js.map
